const EVENTS = {
  SELECT_INTENT: 'onboarding_customer_intent_selected',
};

export default EVENTS;
